import { userService } from "../services/userService";
import vendorStorefrontController from "../controllers/vendorStorefrontController";
import { isApiError, isSuccessResponse } from "./registrationHelpers";

export const initializeRegistrationSession = (userID) => {
  if (!userID || !userService.getJwt()) {
    throw new Error("Missing registration session. Please sign in again.");
  }
  userService.clearUserData();
  return userService.saveUserData({ UserID: userID, Compid: "", BPID: "", BType: "" });
};

// Company creation is already complete when this runs. Retrying must never
// submit the company registration request again.
export const completeRegistrationSession = async ({ isDelivery = false } = {}) => {
  const { UserID, Compid } = userService.getUserData();
  if (!UserID || !Compid || !userService.getJwt()) {
    throw new Error("Missing registration session. Please sign in again.");
  }

  await userService.refreshJwt();
  const payload = userService.getUserPayload();
  if (!payload || payload.id !== UserID) {
    throw new Error("Unable to verify the registration session. Please sign in again.");
  }
  const BPID = payload.userDetails?.[Compid]?.busienssProfileID || "";
  // Delivery companies have no vendor storefront/verticalType contract.
  if (isDelivery) {
    return userService.saveUserData({ UserID, Compid, BPID, BType: "" });
  }
  const response = await vendorStorefrontController.getSettings({
    Authorization: userService.getJwt(),
    companyId: Compid,
  });
  if (isApiError(response) || !isSuccessResponse(response)) throw response;
  const settings = response?.data?.data ?? response?.data?.result ?? response?.data;
  if (settings?.companyId !== Compid ||
      !["RESTAURANTS", "GROCERIES", "PATISSERIE"].includes(settings?.verticalType)) {
    throw new Error("Unable to load the registered company's business type. Please retry.");
  }
  return userService.saveUserData({ UserID, Compid, BPID, BType: settings.verticalType });
};
